// extracted by mini-css-extract-plugin
export default {"root":"TeamMember_root__hjuEC","avatar":"TeamMember_avatar__e5Ro0","name":"TeamMember_name__tHjh-","email":"TeamMember_email__bTy-i"};